export const ru = {
    sync_documents: 'Синхронизировать c Яндекс ID',
    something_went_wrong: 'Что-то пошло не так, обратитесь в чат поддержки',
};
